import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import ProfileScore from './ProfileScore';
import { useAiSearchProfilePopoutContext } from '../../AiSearchProfilePopoutContext';
import { useProfileContactInfo } from '../../../../api/useProfileContactInfo';
import ProfileEmailThread from './ProfileEmailThread/ProfileEmailThread';

const ProfileExtra = () => {
    const { selectedProfile, hideEmailThreads } = useAiSearchProfilePopoutContext();
    const { data } = useProfileContactInfo(selectedProfile?.url);
    const hasEmail = !!data?.personalEmailAvailable || !!data?.workEmailAvailable;
    const [tab, setTab] = useState(hasEmail ? UIStrings.Email : UIStrings.RankingCriteria);

    return (
        <div className="flex min-w-0 flex-1 flex-col gap-2">
            {hideEmailThreads ? (
                <div className="flex flex-col gap-2">
                    <h4 className="text-base font-semibold tracking-tight">{UIStrings.RankingCriteria}</h4>
                    <ProfileScore />
                </div>
            ) : (
                <Tabs value={tab} onValueChange={setTab} className="flex min-h-0 flex-1 flex-col gap-0">
                    <TabsList variant="default" className="w-full rounded-lg">
                        <TabsTrigger className="rounded-md" value={UIStrings.Email}>
                            {UIStrings.Email}
                        </TabsTrigger>
                        <TabsTrigger className="rounded-md" value={UIStrings.RankingCriteria}>
                            {UIStrings.RankingCriteria}
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value={UIStrings.Email} className="mt-3 flex min-h-0 flex-1 flex-col outline-none">
                        <ProfileEmailThread />
                    </TabsContent>
                    <TabsContent
                        value={UIStrings.RankingCriteria}
                        className="mt-3 flex min-h-0 flex-1 flex-col outline-none"
                    >
                        <ProfileScore />
                    </TabsContent>
                </Tabs>
            )}
        </div>
    );
};

export default ProfileExtra;
